<template>
    <!-- 属性模块 -->
    <div class="camera" id="CAMERA-SWF">
        <div class="mask" v-show="mask_visible"></div>
        <div class="option">
            <el-radio-group v-model="camera_data" @change="handleChangeOption">
                <div class="item"><el-radio :label="0">直接切换</el-radio></div>
                <div class="item"><el-radio :label="0.15">快闪(0.15秒)</el-radio></div>
                <div class="item"><el-radio :label="0.5">中速(0.5秒)</el-radio></div>
                <div class="item"><el-radio :label="1">稍慢(1秒)</el-radio></div>
                <div class="item"><el-radio :label="2.5">慢速(2.5秒)</el-radio></div>
                <div class="item"><el-radio :label="4">很慢(4秒)</el-radio></div>
                <div class="item"><el-radio :label="6">极慢(6秒)</el-radio></div>
                <div class="item"><el-radio :label="7">自定义时长</el-radio>&nbsp &nbsp
                <input class="custom_input" type="text" style="width:40px;left:10px;" v-model="camera_value" :disabled="camera_data != '7'" @keydown="checkKeydown(camera_value)" @input="cameraInput()" @blur="handleChangeSliderOption"> &nbsp<span style="color:#fff;">秒</span>
                </div>
                <div class="slider">
                    <!-- <input class="custom_input" type="text" v-model="camera_value" :disabled="camera_data != '7'" @keydown="checkKeydown(camera_value)" @input="cameraInput()" @blur="handleChangeSliderOption"> -->
                    <!-- <span class="l">0</span>
                    <span class="r">10</span>
                    <el-slider style="-webkit-transform:scale(0.55);width:330px;left:-70px;position:relative;" v-model="camera_value" :format-tooltip="formatTooltip" :disabled="camera_data != '7'" @change="handleChangeSliderOption"></el-slider> -->
                </div>
                <div class="item">
                    <el-radio :label="8" :disabled="follow_ids.length == 0 && follow_alias.length == 0">镜头跟随<span v-if="follow_ids.length == 0 && follow_alias.length == 0">：无</span></el-radio>
                    <div class="list">
                        <div class="item" v-for="item, index in follow_alias" @click="handleChangeCameraOption(item)">
                            <img :src="camera_follow_res[follow_ids[index]].thumb" v-if="camera_follow_res[follow_ids[index]] !=null">
                        </div>
                    </div>
                </div>
            </el-radio-group>
        </div>
        <div class="line"></div>
        <div class="group clearfix">
            <div class="item" @click="handleChangeButtonOption">
                <div class="icon-scene_-engagement"></div>
                <div class="text">衔接上一画面</div>
            </div>
        </div>
        <div class="line"></div>
        <div class = "camera_transition">
            <div class = "content">
                <div class="item text">镜头缓动: </div>
                <el-select v-model = "transition" class = "item select" v-bind:disabled="!transition_visible" @change="handleTransitionChange">
                    <el-option
                    v-for="item in transitionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="font-size: 12px;">
                    </el-option>
                </el-select>
            </div>
        </div>
        <!-- Psocket 组件 -->
        <psocket :attributes="attributes" :flashvars="flashvars" v-if="platform == 'qt'"></psocket>
    </div>
</template>
<script>
    // Psocket 组件
    import Psocket from '@/components/Flash/PSocket'
    // 通讯协议
    import Protocol from '@/common/scripts/protocol.js'
    export default {
        // 组件
        components: {
            Psocket
        },
        // 计算
        computed: {
        },
        data () {
            return {
                platform: this.$route.query.platform,
                init: '',
                current_camera_obj: {},
                camera_data: 0,
                camera_value: 0,
                custom: false,
                duration: 0,
                transition: "linear",
                transitionList:[
                    {label:"无", value:"linear"},
                    {label:"先慢后快", value:"easeIn"},
                    {label:"弹性进", value:"easeInElastic"},
                    {label:"返回进", value:"easeInBack"},
                    {label:"跳跃进", value:"easeInBounce"},
                    {label:"先快后慢", value:"easeOut"},
                    {label:"弹性出", value:"easeOutElastic"},
                    {label:"返回出", value:"easeOutBack"},
                    {label:"跳跃出", value:"easeOutBounce"},
                    {label:"缓进缓出", value:"easeInOut"},
                    {label:"弹性进出", value:"easeInOutElastic"},
                    {label:"返回进出", value:"easeInOutBack"},
                    {label:"跳跃进出", value:"easeInOutBounce"}
                ],
                transition_visible: false,
                follow_ids: [],
                follow_alias: [],
                camera_follow_res: [],
                // -------------------------------------------------- [ FLASH ] --------------------------------------------------
                flashvars: {
                    module: CAMERA_NAME
                },
                attributes: {
                    id: CAMERA_NAME + '-PSOCKET'
                },
                // 遮罩层
                mask_visible: true,
                // listById cache
                listByIdsCache:[],
                checkvalue:'',
            }
        },
        methods: {
            checkKeydown(value){
                this.checkValue = value
                console.log('----------------- ' + value)
            },

            cameraInput(){
                this.camera_value=/^\d+\.?\d{0,2}$/.test(this.camera_value)|| this.camera_value == '' ? this.camera_value : this.camera_value = this.checkValue
            },

            sendCameraChange (falias)
            {
                if((this.current_camera_obj.duration == this.duration &&
                    this.current_camera_obj.custom == this.custom &&
                    this.current_camera_obj.transition == this.transition) ||
                    (falias != "" && this.followingalias == falias)) {
                    return;
                }
                let  platform = this.$route.query.platform
                let camera_scene_6_18 = {
                    packageId: 0,
                    senderId: CAMERA,
                    senderName: CAMERA_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 18,
                    protoBytesType: 'proto.com.proto.scene.MCamera',
                    protoBytes: Protocol.serializeBinary(new proto.com.proto.scene.MCamera(), {
                        setDuration: this.duration.toString(),
                        setFollowingalias: falias.toString(),
                        setFollowidlistList: [],
                        setFollowaliaslistList: [],
                        setCustom: this.custom,
                        setTransition: this.transition
                    })
                }
                //console.log("------>this.duration=" + this.duration.toString() + " this.custom=" + this.custom + " this.transition=" + this.transition)
                Protocol.sender(platform, camera_scene_6_18)
            },

            handleChangeCameraOption (alias)
            {
                this.camera_data = 8;
                this.custom = false;
                this.duration = -1;
                this.sendCameraChange(alias)
            },

            handleChangeSliderOption ()
            {
                // let duration = parseFloat(this.camera_value / 10);
                this.custom = true;
                this.duration = parseFloat(this.camera_value);
                this.sendCameraChange("");
            },

            handleChangeOption(value)
            {
                if(value == 0 || value == 8)
                {
                    this.transition = this.transitionList[0].value;
                }
                if (value == 7 || value == 8) {
                    return false;
                }
                this.custom = false;
                this.duration = value;
                this.sendCameraChange("");
            },

            handleTransitionChange(value)
            {
                this.transition = value;
                //console.log('-------------------> transition='  + this.transition)
                this.sendCameraChange("");
            },

            handleChangeButtonOption()
            {
                let platform = this.$route.query.platform
                let camera_scene_6_25 = {
                    packageId: 0,
                    senderId: CAMERA,
                    senderName: CAMERA_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 25,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, camera_scene_6_25)
            },

            formatTooltip(value)
            {
                return value / 10
            },

            handlePostList (id)
            {
               let param = this.ListByIdCache.check(id)
                // console.log('-------------------> listByIds Camera'  + JSON.stringify(param))
                this.camera_follow_res = param.cache;
                if(param.newId.length) {
                    let URL = process.env.HOST + '/pro/api/matter/listByIds'
                    let params = 'id=' + param.newId.toString()
                    let headers = {
                        'token': this.has_token,
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    }
                    this.AJAX.post(URL, headers, params).then((data)=>{
                        let objs = [];
                        for(var id in data.result) {
                            objs[id] = data.result[id];
                        }
                        for(var id in this.camera_follow_res) {
                            objs[id] = this.camera_follow_res[id];
                        }
                        this.camera_follow_res = objs;
                        // 将新的id data添加到缓存中
                        this.ListByIdCache.cacheIdData(data.result)
                        // console.log('新请求得的数据 ===> ' + JSON.stringify(data.result))
                    }).catch((err)=>{
                        this.$message({
                            message: err.msg||err.message,
                            type: 'error'
                        })
                    })
                }
               
                // let URL = process.env.HOST + '/pro/api/matter/listByIds'
                // let params = 'id=' + id.toString()
                // let headers = {
                //     'token': this.has_token,
                //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                // }
                // this.AJAX.post(URL, headers, params).then((data)=>{
                //     this.camera_follow_res = data.result
                //     console.log('MMM' + JSON.stringify(data))
                // }).catch((err)=>{
                //     this.$message({
                //         message: err.msg||err.message,
                //         type: 'error'
                //     })
                // })
            },
        },

        mounted ()
        {
            let platform = this.$route.query.platform
            let _this = this
            // 模块 CAMERA
            // 模块初始化
            Protocol.onSocketInit(platform, CAMERA_NAME, CAMERA)
            // 模块与服务器建立链接
            Protocol.onSocketConnect(platform, CAMERA_NAME)
            // 模块与服务器建立链接
            Protocol.onSocketRegister(platform, CAMERA_NAME, CAMERA)
            // 接收消息
            Protocol.receiver(platform, CAMERA_NAME)
            window[CAMERA_NAME].domReady = () => {
                // 检查场景是否加载完成
                let camera_scene_6_26 = {
                    packageId: 0,
                    senderId: CAMERA,
                    senderName: CAMERA_NAME,
                    receiverId: SCENE,
                    receiverName: SCENE_NAME,
                    timeFlag: new Date().getTime(),
                    sessionId: 6,
                    messageId: 26,
                    protoBytesType: '',
                    protoBytes: []
                }
                // 发送消息
                Protocol.sender(platform, camera_scene_6_26)
            }
            window[CAMERA_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {
                if(sessionId == 2 && messageId == 5) {
                    let camera_scene_6_6 = {
                        packageId: 0,
                        senderId: CAMERA,
                        senderName: CAMERA_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 6,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, camera_scene_6_6)
                }else if(sessionId == 6 && messageId == 5) {
                    _this.init = 'complete'
                    console.log('[' + CAMERA_NAME + '][COMPLETE]')
                    _this.mask_visible = false
                    let camera_scene_6_6 = {
                        packageId: 0,
                        senderId: CAMERA,
                        senderName: CAMERA_NAME,
                        receiverId: SCENE,
                        receiverName: SCENE_NAME,
                        timeFlag: new Date().getTime(),
                        sessionId: 6,
                        messageId: 6,
                        protoBytesType: '',
                        protoBytes: []
                    }
                    // 发送消息
                    Protocol.sender(platform, camera_scene_6_6)
                }else if(sessionId == 6 && messageId == 7) {
                    _this.current_camera_obj = Protocol.deserializeBinary('proto.com.proto.scene.MCamera', protoBytes).toObject();
                    let originDur = _this.current_camera_obj.duration
                    _this.current_camera_obj.duration = parseFloat(_this.current_camera_obj.duration.toFixed(2));
                    _this.transition = _this.current_camera_obj.transition;
                    if(_this.transition == "")
                    {
                        _this.transition = _this.transitionList[0].value;
                    }
                    //console.log('_this.transition====== > '  + _this.transition)
                    if(_this.current_camera_obj.followidlistList) {
                        _this.follow_ids = _this.current_camera_obj.followidlistList;
                    }
                    if(_this.current_camera_obj.followaliaslistList) {
                        _this.follow_alias = _this.current_camera_obj.followaliaslistList;
                    }
                    if (_this.follow_ids && _this.follow_ids.length > 0) {
                        _this.handlePostList(_this.follow_ids);
                    }else {
                        _this.camera_follow_res = [];
                    }
                    let value = parseFloat(_this.current_camera_obj.duration);
                    if(_this.current_camera_obj.custom) {
                        _this.camera_data = 7;
                        // _this.camera_value = parseFloat((originDur*10).toFixed(2));
                        _this.camera_value = parseFloat((originDur).toFixed(2));
                        // console.log('====== > m '  + (originDur*10).toFixed(2))
                    }else if (_this.current_camera_obj.duration == 0 && !_this.current_camera_obj.custom) {
                        _this.camera_data = 0
                    } else if (_this.current_camera_obj.duration == 1) {
                        _this.camera_data = 1
                    }else if (_this.current_camera_obj.duration == -1) {
                        _this.camera_data = 8
                    } else if (value >= 0.15 && value < 0.16) {
                        _this.camera_data = 0.15
                    } else if (value == 0.5 || value == 2.5 || value == 4 || value == 6) {
                        _this.camera_data = value
                    }else {
                        _this.camera_data = 7
                        _this.camera_value = parseFloat((value*10).toFixed(2));
                    }
                    //
                    if(_this.camera_data == 0 || _this.camera_data == 8)
                    {
                        _this.duration = 0;
                        _this.transition_visible = false;
                        
                    }  else if(_this.camera_data == 8)
                    {
                        _this.duration = -1;
                        _this.transition_visible = false;
                    } else if(_this.camera_data == 7)
                    {
                        _this.duration = _this.camera_value;
                        _this.transition_visible = true;
                    } else {
                        _this.duration = _this.camera_data;
                        _this.transition_visible = true;
                    }
                }else if (sessionId == 1 && messageId == 12) { // changeTab
                    _this.mask_visible = true
                }else if(sessionId == 1 && messageId == 13){ // 锁定模块
                    _this.mask_visible = true
                }else if(sessionId == 1 && messageId == 14){ // 解除锁定
                    _this.mask_visible = false
                }
            }
        },

        watch: {

            'camera_value':function(){
                if(typeof this.camera_value == 'number'){
                    this.camera_value = this.camera_value.toString()
                }
                // )[0] /[^\.\d]/g  /[^\d*(\.?\d{1,2}]/g
                this.camera_value = this.camera_value.replace(/[^\.\d]/g,'')
                if(this.camera_value > 30){
                    this.camera_value = '30.00'
                }
            },
        }
    }
</script>
<style lang="stylus">
    .camera {
        background: #505050//#e8e8e8
        position: absolute
        top: 0
        right: 0
        bottom: 0
        left: 0
        .mask {
            position: absolute
            top: 25px
            right: 0
            bottom: 0
            left: 0
            width: 280px
            background: #3a3a3a//rgba(255, 255, 255,.8)
            z-index: 1
        }
        .option {
            padding: 15px 5px
            .el-radio-group {
                display: block
                font-size: 12px
            }
            .item {
                padding: 10px
                .el-radio__inner {
                    width: 14px
                    height: 14px
                    // background:green
                }
                .el-radio__label {
                    font-size: 12px
                    color:#e2e2e2
                }
                .list {
                    overflow: hidden
                    margin-left: 20px
                    margin-top: 10px
                    .item {
                        float: left
                        width: 26px
                        height: 26px
                        border: 1px solid #ccc
                        margin-right: 5px
                        padding: 2px
                        overflow: hidden
                        background: #fff
                        img {
                            display: block
                            width: 100%
                        }
                    }
                    .active {
                        border: 1px solid #f00
                    }
                }
            }
            .slider {
                padding-left: 50px
                padding-right: 40px
                position: relative
                .l {
                    position: absolute
                    left: 30px
                    top: 12px
                    color:#e2e2e2
                }
                .r {
                    position: absolute
                    right: 10px
                    top: 12px
                    color:#e2e2e2
                }
                .el-slider__runway {
                    background: #fff
                }
                .custom_input{
                    width:40px
                    background:#fff
                .disabled{
                       background:#c7c7c7
                }
                }
            }
        }
        .group {
            padding: 15px
            color: #000
            cursor: pointer
            .item {
                float: left
                text-align: center
            }
            .icon-scene_-engagement {
                font-size: 32px
                color:#fff
            }
            .text {
                font-size: 12px
                -webkit-transform: scale(0.8)
                color:#e2e2e2
            }
        }
        .camera_transition {
            padding-left:18px
            padding-right:18px
            padding-top:12px
            .content{
                position: absolute
                vertical-align: middle
                .item {
                    position: relative
                    float: left
                    display:inline-block
                }
                .text {
                    padding-top: 10px
                    font-size: 12px
                    color:#e2e2e2
                }
                .select {
                    margin-left: -10px
                    width: 188px
                    height: 17px
                    font-size: 12px
                    -webkit-transform: scale(0.8)
                }
            }
            
            
        }
           
    }
</style>



// WEBPACK FOOTER //
// Camera.vue?77565648